<template>
  <div>
    <o-section :overlay="true">
      <o-text-input type="search" placeholder="Zoeken" icon="search" />
    </o-section>
    <o-section :overlay="true">
      <o-list-item
        :label="klasse"
        :no-padding="true"
        v-for="klasse in klasses"
        :key="`klasse${klasse}`"
      />
    </o-section>
  </div>
</template>

<script>
import OListItem from '@/components/base/OListItem.vue'
export default {
  name: 'OEditKlasse',
  components: {
    OListItem
  },
  data: () => ({
    klasses: [
      'XS Cargobike',
      'S Micro - 2 + 2 pl.',
      'S Micro autom. - 2 + 2 pl.',
      'S Mini',
      'S Mini autom.',
      'S e-cambio autom.'
    ]
  })
}
</script>
